"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUserVaultBalances = fetchUserVaultBalances;
const maps_js_1 = require("../../common/maps.js");
const client_js_1 = require("../client.js");
const getPortfolioAmounts_js_1 = require("./getPortfolioAmounts.js");
async function fetchUserVaultBalances(address, poolName, ignoreCache) {
    const suiClient = (0, client_js_1.getSuiClient)();
    let vaultBalance;
    if (maps_js_1.poolInfo[poolName].parentProtocolName === "ALPHAFI") {
        const lockedPortfolioAmount = await (0, getPortfolioAmounts_js_1.getAlphaPortfolioAmount)("ALPHA", {
            suiClient,
            address,
            isLocked: true,
        }, ignoreCache);
        const lockedPortfolioAmountInUSD = await (0, getPortfolioAmounts_js_1.getAlphaPortfolioAmountInUSD)("ALPHA", { suiClient, address, isLocked: true }, ignoreCache);
        const unlockedPortfolioAmount = await (0, getPortfolioAmounts_js_1.getAlphaPortfolioAmount)("ALPHA", {
            suiClient,
            address,
            isLocked: false,
        }, ignoreCache);
        const unlockedPortfolioAmountInUSD = await (0, getPortfolioAmounts_js_1.getAlphaPortfolioAmountInUSD)("ALPHA", { suiClient, address, isLocked: false }, ignoreCache);
        const portfolioAmount = await (0, getPortfolioAmounts_js_1.getAlphaPortfolioAmount)("ALPHA", {
            suiClient,
            address,
        }, ignoreCache);
        const portfolioAmountInUSD = await (0, getPortfolioAmounts_js_1.getAlphaPortfolioAmountInUSD)("ALPHA", {
            suiClient,
            address,
        }, ignoreCache);
        if (lockedPortfolioAmount !== undefined &&
            lockedPortfolioAmountInUSD !== undefined &&
            unlockedPortfolioAmount !== undefined &&
            unlockedPortfolioAmountInUSD !== undefined &&
            portfolioAmount !== undefined &&
            portfolioAmountInUSD !== undefined) {
            const res = {
                lockedAlphaCoins: lockedPortfolioAmount,
                lockedAlphaCoinsInUSD: lockedPortfolioAmountInUSD,
                unlockedAlphaCoins: unlockedPortfolioAmount,
                unlockedAlphaCoinsInUSD: unlockedPortfolioAmountInUSD,
                totalAlphaCoins: portfolioAmount,
                totalAlphaCoinsInUSD: portfolioAmountInUSD,
            };
            vaultBalance = res;
        }
    }
    else if (maps_js_1.poolInfo[poolName].assetTypes.length === 2) {
        const portfolioAmount = await (0, getPortfolioAmounts_js_1.getPortfolioAmount)(poolName, address, ignoreCache);
        const portfolioAmountInUSD = await (0, getPortfolioAmounts_js_1.getDoubleAssetPortfolioAmountInUSD)(poolName, address, ignoreCache);
        if (portfolioAmount !== undefined && portfolioAmountInUSD !== undefined) {
            const res = {
                coinA: portfolioAmount[0].toString(),
                coinB: portfolioAmount[1].toString(),
                valueInUSD: portfolioAmountInUSD,
            };
            vaultBalance = res;
        }
    }
    else if (maps_js_1.poolInfo[poolName].assetTypes.length === 1) {
        const portfolioAmount = await (0, getPortfolioAmounts_js_1.getSingleAssetPortfolioAmount)(poolName, address, ignoreCache);
        const portfolioAmountInUSD = await (0, getPortfolioAmounts_js_1.getSingleAssetPortfolioAmountInUSD)(poolName, address, ignoreCache);
        if (portfolioAmount !== undefined && portfolioAmountInUSD !== undefined) {
            const res = {
                coin: portfolioAmount.toString(),
                valueInUSD: portfolioAmountInUSD,
            };
            vaultBalance = res;
        }
    }
    return vaultBalance;
}
//# sourceMappingURL=fetchUserVaultBalances.js.map